import React from "react";
import { MapPin, Globe2 } from "lucide-react";

const HOUSTON_IMG =
  "https://images.unsplash.com/photo-1675881851603-b978bca51f41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxob3VzdG9uJTIwc2t5bGluZSUyMG5pZ2h0JTIwZGFya3xlbnwwfHx8fDE3Nzc2Njc1NjV8MA&ixlib=rb-4.1.0&q=85";

const NEIGHBORHOODS = [
  "Downtown",
  "Midtown",
  "The Heights",
  "Montrose",
  "Memorial",
  "River Oaks",
  "Sugar Land",
  "Katy",
  "The Woodlands",
  "Pearland",
  "Cypress",
  "Galleria",
];

export default function Houston() {
  return (
    <section id="houston" className="relative overflow-hidden" data-testid="houston-section">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HOUSTON_IMG})` }}
      />
      <div className="absolute inset-0 bg-[#0A0A0A]/85" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/70 to-transparent" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#E5B43A]" />
              <MapPin size={14} className="text-[#E5B43A]" />
              <span className="text-xs font-bold tracking-[0.3em] uppercase text-zinc-300">
                Houston HQ
              </span>
            </div>
            <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[0.9]">
              Built in <span className="text-[#E5B43A]">H-Town.</span><br />
              Delivered everywhere.
            </h2>
            <p className="mt-8 text-zinc-300 text-base md:text-lg leading-relaxed max-w-lg">
              Gain Time Fitness is rooted in Houston — serving athletes from
              Downtown to The Woodlands. Our online training platform means
              every drill, every program, and every recovery protocol reaches
              you wherever you are.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6">
              <div className="border-l-2 border-[#E5B43A] pl-4">
                <div className="font-display text-3xl">713</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mt-1">Area Code</div>
              </div>
              <div className="border-l-2 border-zinc-700 pl-4">
                <div className="font-display text-3xl">12+</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mt-1">Neighborhoods Served</div>
              </div>
              <div className="border-l-2 border-zinc-700 pl-4">
                <div className="font-display text-3xl flex items-center gap-1">
                  <Globe2 size={24} className="text-[#E5B43A]" /> 50
                </div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mt-1">States Reachable</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-6 md:col-start-8">
            <div className="border border-zinc-800 bg-[#0A0A0A]/70 backdrop-blur-sm p-8 md:p-10">
              <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#E5B43A] mb-6">
                // Service Area
              </div>
              <div className="flex flex-wrap gap-2">
                {NEIGHBORHOODS.map((n) => (
                  <span
                    key={n}
                    className="border border-zinc-700 px-3 py-2 text-xs tracking-widest uppercase text-zinc-300 hover:border-[#E5B43A] hover:text-white transition-colors"
                    data-testid={`neighborhood-${n.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {n}
                  </span>
                ))}
              </div>
              <div className="mt-8 pt-6 border-t border-zinc-800 text-sm text-zinc-400 leading-relaxed">
                Not in Houston? <span className="text-white font-semibold">No problem.</span>{" "}
                Our online training reaches athletes across every time zone.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
